export const DEV_DOMAIN = ".dev.";
export const LOCAL_DOMAIN = "revm-dash";
export const K8S_DOMAIN = "revenue-management-dashboard";
export const UAT_DOMAIN = ".uat.";
export const USER_PROFILE = "/settings/profile";
export const OKTA_WIDGET_CALLBACK_QS = "authenticating=true";
